export { Marker } from './components/Marker';
export { Map } from './components/Map';
import useGoogleAPI from './components/useGoogleAPI';
import useCoordinates from './components/useCoordinates';
import useCurrentLocation from './components/useCurrentLocation';
import getCurrentAddress from './components/getCurrentAddress';
export default {
  useGoogleAPI: useGoogleAPI,
  useCoordinates: useCoordinates,
  useCurrentLocation: useCurrentLocation,
  getCurrentAddress: getCurrentAddress
};